













import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"

export default {
        name: 'ConsultantLinks',
        data: ()->
            return {
                iframeHeight: 500
                links: [],
                link: {
                    uid: null,
                    label: '',
                    href: ''
                }
            }
        mounted: ()->
            self = @
            @links = @$store.state.consultant_link_set
            uid = @$route.params.uid
            console.log("@links", @links)
            if uid and @links != undefined
                @link = @links.find((link) => link.uid == uid)
            else    
                r = await queries.run("get_consultant_links")
                if r.ok
                    @links = r.body.data.consultant_link_set
                    @link = @links.find((link) => link.uid == uid)

            window.addEventListener('resize', ()->
                self.iframeHeight = $(document).height()-40;
                return
            )
            self.iframeHeight = $(document).height()-40;
        watch: {
            '$route.params.uid': (newUid) ->
                self = @
                uid = newUid
                if uid
                    @link = @links.find((link) => link.uid == uid)
        },
    }
  